"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LargeIconBullseye = function LargeIconBullseye(_ref) {
  var activeTheme = _ref.activeTheme,
      inactiveTheme = _ref.inactiveTheme,
      active = _ref.active;
  var theme = active ? {
    primary: activeTheme[500],
    secondary: activeTheme[200],
    tertiary: activeTheme[50]
  } : {
    primary: inactiveTheme[200],
    secondary: inactiveTheme[100],
    tertiary: inactiveTheme[50]
  };
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "59",
    height: "60",
    fill: "none",
    viewBox: "0 0 59 60"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "23.465",
    cy: "35.614",
    r: "22.465",
    fill: theme.tertiary,
    stroke: theme.primary,
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "23.465",
    cy: "36.062",
    r: "12.319",
    fill: theme.secondary,
    stroke: theme.primary,
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: theme.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M49.864 9.662L23.87 35.655M49.864 9.664V1l-5.776 5.776v8.664"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: theme.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M49.864 9.662h7.942l-5.776 5.776h-7.942"
  }));
};

LargeIconBullseye.propTypes = {
  activeTheme: _propTypes.object,
  inactiveTheme: _propTypes.object,
  active: _propTypes.bool
};
var _default = LargeIconBullseye;
exports.default = _default;